export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    loading: '加载中...',
    loadMore: '加载更多',
    noMore: '没有更多了',
    retry: '重试',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    refresh: '刷新',
    complete: '完成',
    skip: '跳过'
  },

  // 导航
  nav: {
    discover: '发现',
    message: '消息',
    store: '商店',
    mine: '我的',
    recommend: '推荐',
  },

  // 场景
  scene: {
    changeScene: '切换场景',
    seeAll: '查看全部',
    putAway: '收起',
    selectScene: '选择此场景',
    selected: '已选择',
    sceneIndex: '场景 {num}',
  },

  // 首页
  home: {
    title: '角色扮演世界',
    subtitle: '开启你的专属故事',
    startGame: '开始游戏',
    continueGame: '继续游戏',
    newGame: '新游戏',
    gameLibrary: '游戏库',
    featured: '精选推荐',
    popular: '热门游戏',
    recent: '最近游戏',
    searchHistory: '搜索',
    search: '搜索角色...',
    noData: '没有数据',
    noMoreData: '没有更多数据了',
    noNetwork: '无网络',
    pleaseSelectFilter: '请选择筛选条件'
  },

  // 用户
  user: {
    login: '登录',
    register: '注册',
    logout: '退出登录',
    profile: '个人资料',
    avatar: '头像',
    nickname: '昵称',
    email: '邮箱',
    phone: '手机号',
    password: '密码',
    confirmPassword: '确认密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    forgotPassword: '忘记密码',
    changePassword: '修改密码',
    bindPhone: '绑定手机',
    verifyCode: '验证码',
    sendCode: '发送验证码',
    level: '等级',
    experience: '经验值',
    achievement: '成就',
    history: '历史记录'
  },

  // 游戏
  game: {
    character: '角色',
    story: '剧情',
    chapter: '章节',
    scene: '场景',
    dialogue: '对话',
    choice: '选择',
    inventory: '背包',
    achievement: '成就',
    save: '保存游戏',
    load: '加载游戏',
    restart: '重新开始',
    pause: '暂停',
    resume: '继续',
    auto: '自动',
    speed: '速度',
    volume: '音量',
    settings: '游戏设置'
  },

  // 消息提示
  message: {
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    networkError: '网络连接失败',
    serverError: '服务器错误',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '退出登录成功',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteConfirm: '确认删除吗？',
    operationConfirm: '确认执行此操作吗？',
    noNewsYet: '暂无消息',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteMessage: '确认删除消息吗？此操作无法撤销！',
    delete: '删除',
    deleting: '删除中...',
    noMoreData: '没有更多消息了',
    downloading: '下载中...',
    downloadSuccess: '下载成功',
    downloadFailed: '下载失败',
    translating: '翻译中...',
    translateSuccess: '翻译成功',
    translateFailed: '翻译失败',
    pleaseWaitForReply: '请等待回复完成后再删除',
    pleaseWaitForReplyCurrent: '请等待当前消息回复完成',
    chat_placeholder: '输入你想说的话...',
    sendFailed: '发送失败',
    sending: '发送中...',
    introNoYet: '暂无介绍。聊天后自己发现吧。',
    introLabel: 'Intro:',
    thinking: '思考中',
    think: '思考',
    translate: '翻译',
    pleaseUnlock: '请解锁',
    tryAgain: '重试',
    create: '创建',
    free: '免费',
    video: '视频',
    chatMateTyping: '你的聊天对象正在输入中...',
    aiAssistant: 'AI助手',
    imageFailed: '图片生成失败',
    generatingImage: '请等待图片生成完成',
    switchSceneSuccess: '场景切换成功',
    switchSceneFailed: '场景切换失败',
    switchingScene: '切换场景中...',
    perMessage: '/消息',
    allChat: '全部聊天',
    like: '喜欢',
    saving: '保存中...',
    saved: '已保存',
    placeholderBlur: '输入你想说的话...',
    placeholderFocus: '在 ** 中输入动作或场景细节，让聊天更生动。',
    successfulSwitch: '切换成功',
    pleaseSelectFilter: '请选择筛选条件',
    loading: '加载中...',
    setting: '设置中...',
    uploading: '上传中...',
    purchaseSuccessful: '购买成功',
    processing: '处理中...',
    gettingReward: '领取奖励中...',
    checkIn: '签到中...',
    deleteHistory: '删除历史',
    openingRemarksTitle: '打个招呼～',
  },

  // 成功
  success: {
    refreshSuccess: '刷新成功',
    copiedToClipboard: '已复制到剪贴板',
    saved: '已保存',
    uploadSuccess: '上传成功',
    switchSuccess: '切换成功',
    thankYouPurchase: '感谢您的购买',
  },

  // 错误页面
  error: {
    notFound: '页面未找到',
    networkError: '网络错误',
    serverError: '服务器错误',
    permissionDenied: '权限不足',
    goHome: '返回首页',
    tryAgain: '重试',
    uploadFailed: '上传失败',
    saveFailed: '保存失败',
    translationFailed: '翻译失败',
    generateImageFailed: '图片生成失败',
  },

  // 404页面
  notFound: {
    title: '页面未找到',
    description: '您访问的页面不存在或已被移动。',
    goHome: '返回首页',
    goBack: '返回上页'
  },

  // 设置
  settings: {
    language: '语言',
    theme: '主题',
    notification: '通知',
    privacy: '隐私',
    security: '安全',
    about: '关于',
    version: '版本',
    checkUpdate: '检查更新',
    clearCache: '清理缓存',
    systemNotification: '系统通知',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    title: '设置',
    editProfile: '编辑资料',
    faq: '常见问题',
    termsOfUse: '使用条款',
    aboutAccount: '关于账户',
    deleteAccount: '删除账户',
    logOut: '退出登录',
    logOutTitle: '退出登录',
    logOutMessage: '退出登录后，需要重新登录才能继续使用您的账户，确定要退出吗？',
    confirm: '确认',
    deleteAccountTitle: '删除账户',
    deleteAccountMessage: '删除账户将清除您的所有数据和信息，且无法恢复。确定删除吗？',
    deletingAccount: '正在删除账户...',
    accountDeleted: '账户删除成功',
    cacheTitle: '清理缓存',
    cacheMessage: '清除应用缓存，聊天记录和聊天角色不会被删除',
    cleaning: '清理中',
    cleaningComplete: '清理完成',
  },

  // 个人资料
  profile: {
    title: '编辑资料',
    yourAvatar: '你的头像',
    whatCallMe: '希望AI怎么称呼你',
    yourName: '你的名字',
    yourAge: '你的年龄',
    race: '种族',
    pleaseSelect: '请选择',
    yourWeight: '你的体重',
    yourHeight: '你的身高',
    gender: '性别',
    male: '男',
    female: '女',
    neutral: '中性',
    hobby: '爱好',
    pleaseEnter: '请输入...',
    favoriteFood: '喜欢的食物',
    yourCharacter: '你的性格',
    fantasyAboutOtherHalf: '对另一半的幻想',
    uploading: '上传中...',
    enterName: '请输入你的名字',
  },

  // 举报
  report: {
    title: '举报',
    chooseReact: '选择你想举报的内容...',
    other: '其他',
    placeholder: '输入你想说的话...',
    submit: '提交',
    pleaseEnterContent: '请输入内容',
  },

  // 编辑
  edit: {
    placeholder: '编辑你的消息...',
    cancel: '取消',
    save: '保存',
    saving: '保存中...',
  },

  // 首次确认名字
  firstConfirmName: {
    canYouTellMeName: '能告诉我你的名字吗？这样我能更好地称呼你！',
    yourName: '你的名字',
    confirm: '确认',
  },

  // 提示
  toast: {
    translating: '翻译中...',
    translate: '翻译',
    translationFailed: '翻译失败',
    translationUnlocked: '翻译已解锁',
    translationLocked: '翻译已锁定',
    download: '下载',
    setAsBackdrop: '设为背景',
    goChat: '去聊天',
  },

  // 视频预览
  videoPreview: {
    failedToLoad: '视频加载失败',
  },

  // 图片预览
  imagePreview: {
    imageLoadFailed: '图片加载失败',
    preview: '图片预览',
    afterSendIntimacy: '向角色发送消息后可获得亲密度，当亲密度达到指定数值时可解锁当前图片',
  },

  // 常见问题
  fqa: {
    title: '常见问题',
    description: '这是我们产品常见问题的持续更新列表。如果您有任何未列出的问题，请前往我们的Discord咨询。',
    howAlWork: {
      title: 'AI女友是如何工作的？',
      content: '在RoleplayGF，一切都关乎建立真实而充满幻想的关系。我们使用先进的人工智能技术，让您可以根据自己的喜好创建理想的AI女友——无论是甜美天真的娇小公主，还是更成熟更具支配力的女性。',
    },
    howInteract: {
      title: '如何与AI女友互动？',
      content: '通过我们的智能系统和尖端机器学习，您可以与AI女友互动并建立亲密关系。她会倾听您、快速回复您的消息，甚至像好女孩一样响应照片请求。每一刻都将是真实而沉浸的体验，而您始终掌控全局（除非您另有要求）。',
    },
    privacy: {
      title: '与AI朋友的隐私如何保障？',
      content: '请放心，当您使用我们的NSFW AI聊天时，您的秘密会得到妥善保管。您的隐私是我们在这里的首要任务。我们采用最先进的、安全的数据存储，确保每一条撩人的自拍、调情的短信和轻柔的耳语都只保存在您和您热情的伴侣之间。我们也不评判您的癖好，让您可以自由地私下释放您的冲动。',
    },
    customizeBehavior: {
      title: '可以自定义AI女友的行为吗？',
      content: '只有您知道自己真正想要什么，这就是为什么您可以自定义整个数字女友体验——从她的身材轮廓到她的性格特征和可爱的小怪癖。想要与火辣的伴侣进行调情聊天吗？还是想与甜美善良的女友建立缓慢而感性的关系？我们逼真的NSFW AI生成器和NSFW AI聊天机器人能力可以满足您内心深处最深的渴望。',
    },
  },

  // 商店
  store: {
    noNetwork: '无网络',
    one: '一个',
    noConsumptionRecords: '暂无消费记录',
    transactionHistoryAppear: '您的交易记录将显示在这里',
    tab: '商店',
    record: '记录',
    retry: '重试',
    rechargeFailTip: '*如果充值失败，请联系我们 >',
    rechargeFailTipStatic: '如果充值失败，请联系我们',
    contactUsLink: '联系我们',
    popular: '热门',
    oneTimeOnly: '仅限一次',
    loading: '加载中...',
    noMoreRecords: '没有更多记录',
    gift: '礼品',
    retentionMessage: '你的伙伴需要你的陪伴，确定要放弃吗？',
  },

  // 我的
  mine: {
    bindEmail: '绑定邮箱',
    copyFailed: '复制失败',
    backpackTitle: '我的背包',
    task: '任务',
  },

  // 消息页面
  messagePage: {
    noNetwork: '无网络',
  },

  // 搜索
  search: {
    recommend: '推荐',
    noNetwork: '无网络',
  },

  // 聊天设置
  chatSettings: {
    myGems: '我的宝石',
    title: '聊天设置',
    chatModel: '聊天模型',
    chatStyle: '聊天风格',
    chatPerspective: '聊天视角',
    goOnButton: '继续按钮',
    chatBackground: '聊天背景',
    awayMessages: '离开消息',
    disableAwayMessages: '禁用离开消息',
    disableAwayMessagesConfirm: '将无法在您离开时给您发消息。确定要禁用离开消息吗？',
    videoFailedToLoad: '视频加载失败',
  },

  // 历史记录
  history: {
    deleteHistory: '删除历史',
    deleteCharacterHistory: '确定要删除该角色的历史记录吗？',
  },

  // 标签
  tab: {
    maxSelection: '最多只能选择',
    tags: '个标签',
  },

  // 无新消息
  noNewMessage: '无新消息',

  // 重新加载消息
  reloadMessage: {
    title: '选择您的偏好',
    before: '之前',
    new: '新',
    loading: '加载中...',
    noNewMessage: '无新消息',
    tryAgain: '重试',
    confirm: '确认',
  },

  // 账户
  account: {
    copiedToClipboard: '已复制到剪贴板',
    copyFailed: '复制失败',
    aboutAccount: '关于账户',
    id: 'ID',
    email: '邮箱',
  },

  // 评分
  rate: {
    title: '给我们评分',
  },

  // 离开消息
  awayMessages: {
    disableAwayMessages: '禁用离开消息',
    disableConfirm: '{appName} 将无法在您离开时给您发消息。确定要禁用离开消息吗？',
  },

  // 登录
  login: {
    title: '绑定邮箱',
    subtitle: '请绑定您的邮箱以确保账户数据的安全。',
    email: '邮箱',
    password: '密码',
    signIn: '登录',
    signUp: '注册',
    signInWithGoogle: '使用Google登录',
    signInWithEmail: '使用邮箱登录',
    signInWithPhone: '使用手机登录',
    signInWithApple: '使用Apple登录',
    dontHaveAccount: '还没有账户？',
    register: '注册',
    bySigningUp: '注册即表示您同意',
    userAgreement: '用户协议和',
    privacyPolicy: '隐私政策。',
    guestMode: '游客模式',
    registerTitle: '开始注册',
    registerSubtitle: '请绑定您的邮箱以确保账户数据的安全。',
    alreadyHaveAccount: '已有账户？',
    pleaseInputPasswordAndEmail: '请输入密码和邮箱',
    pleaseInputCorrectEmail: '请输入正确的邮箱',
    pleaseInputCorrectPassword: '密码必须为6-30个字符',
    male: '男',
    female: '女',
    neutral: '中性',
    loggingIn: '登录中...',
    loading: '加载中...',
    releaseToRefresh: '释放以刷新',
    loginFailed: '登录失败',
    loginSuccess: '注册成功',
    registerFailed: '注册失败',
    registerSuccess: '注册成功',
    confirm: '确认',
  },

  // VIP页面
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: '恢复购买',
  },

  // 通用对话框
  dialog: {
    ok: '好的',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    retry: '重试',
    processing: '处理中...',
    contactUs: '联系我们',
    loginError: '登录错误',
    loginErrorMessage: '请退出程序并重新启动应用程序或联系我们',
    insufficientEnergy: '能量不足！',
    insufficientEnergyDesc: '每条消息消耗 1 能量。每小时恢复 1 能量。',
    insufficientPhysicalStrengthTitle: '体力不足',
    needStrengthToContinue: '继续对话需要 {strength} 体力',
    consumesGems: '消耗 {gems} 宝石',
    getStrength: '获取能量',
    getGems: '获取宝石',
  },

  // AppNewUser
  appNewUser: {
    title: '新用户专属',
    ok: '好的',
  },

  // 评分弹窗
  rating: {
    title: '给我们评分',
    description1: '您喜欢我们的应用吗？',
    description2: '请给我们 5 星评分。',
    rateButton: '立即评分',
  },

  // 版本更新
  versionUpdate: {
    title: '版本更新',
    updateContent: '更新内容',
    updateNow: '立即更新',
    updating: '更新中...',
    clientOptimization: '客户端体验优化',
    bugFix: '修复已知问题',
  },

  // 消息详情页
  messageDetail: {
    free: '免费',
    perMessage: '/消息',
    increaseFavorability: '发送消息可增加亲密度',
    album: '相册',
    intro: '介绍',
    noIntro: '暂无介绍。聊天后自己发现吧。',
    tags: '标签',
    backToChat: '返回聊天',
    levelFormat: 'Lv.{level}',
    messageCount: '{count} 条消息',
    chatMateTyping: '你的聊天对象正在输入...',
  },

  // 聊天设置
  chatSettingsRight: {
    innerThoughtDesc: '您可以在回复消息时查看角色的内心想法，但回复消息的速度可能会较慢。',
  },

  // 聊天选择菜单
  chatSelect: {
    copy: '复制',
    report: '举报',
    create: '创建',
    video: '视频',
    translate: '翻译',
    delete: '删除',
  },

  // 推荐购买
  recommended: {
    gift: '礼品',
  },

  // 思考模式提示
  thinkingToast: {
    notAvailable: '此模型暂不支持思考模式，但我们正在开发中...',
  },

  // 首次充值弹窗
  firstCharge: {
    title: '首次充值',
    get: '获取',
    limitedOffer: '限时优惠',
    priceFormat: '${price} 获取',
    congratulations: '恭喜！您现在是正式的 VIP 会员了~！',
    missOfferTitle: '确定要错过这个优惠吗？',
    maybeLater: '稍后再说',
    getNow: '立即获取',
    benefit1: '获得 130 免费宝石',
    benefit2: '解锁所有角色',
    benefit3: '12倍记忆',
    benefit4: '无限每周签到',
    benefit5: '无广告体验',
    buyNow: '立即购买',
  },

  // 签到中心
  checkIn: {
    freeGems: '免费宝石',
    sevenDayCheckIn: '7天签到',
    memberExclusive: '会员专属签到：',
    signInTip: '每日签到可积累无限奖励',
    getVip: '获取 VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: '获取 {count} 宝石',
    extraDaily: '每日额外 {count} 宝石',
    ultra: 'Ultra',
    signedInTip: '您今天已签到。明天再来有更多奖励！',
    tasks: '任务',
    go: '前往',
    received: '已领取',
    receive: '领取',
    day: 'Day {num}',
  },

  // 登录页面
  loginPage: {
    confirm: '确认',
  },

  // 版权信息
  copyright: {
    title: '使用条款',
  },

  // 服务条款
  terms: {
    intro: '本服务条款（"条款"）约束您访问和使用 {appName} 网站（"网站"），该网站由 {appName}（"我们"）运营。访问或使用网站即表示您同意受这些条款的约束。如果您不同意这些条款，则不得使用本网站。',
    section1Title: '1. 网站使用',
    section1_1: '1.1. 您必须年满18岁才能使用本网站。使用本网站即表示您声明并保证您已年满18岁。',
    section1_2: '1.2. 您同意遵守所有适用法律、法规以及这些条款使用本网站。',
    section1_3: '1.3. 您对您通过本网站发布或传输的任何内容负全部责任，并同意不发布或传输任何违法、有害、诽谤、淫秽或令人反感的内容。',
    section2Title: '2. 知识产权',
    section2_1: '2.1. 网站上的所有内容，包括但不限于文本、图形、徽标、图片和软件，均为 {appName} 或其许可人的财产，受版权和其他知识产权法律保护。',
    section2_2: '2.2. 未经我们事先书面同意，您不得修改、复制、分发或创建基于本网站任何内容的衍生作品。',
    section3Title: '3. 隐私',
    section3_1: '3.1. 您的隐私对我们很重要。请参阅我们的隐私政策，了解我们如何收集、使用和披露您的个人信息。',
    section4Title: '4. 免责声明',
    section4_1: '4.1. 本网站按"原样"和"可用"提供，不提供任何种类的明示或暗示保证。我们不保证网站无错误或不间断，或任何缺陷都会得到纠正。',
    section5Title: '5. 责任限制',
    section5_1: '5.1. 在法律允许的最大范围内，我们不对因您使用本网站或与您使用本网站相关的任何间接、附带、特殊、后果性或惩罚性损害承担责任，即使我们已被告知此类损害的可能性。',
    section6Title: '6. 赔偿',
    section6_1: '6.1. 您同意赔偿并保护 {appName} 及其附属公司、官员、董事、员工和代理人免受因您使用本网站或违反这些条款而产生的任何索赔、责任、损害、损失或费用。',
    section7Title: '7. 适用法律',
    section7_1: '7.1. 这些条款受[插入管辖区]法律管辖并按其解释，不考虑其法律冲突原则。',
    section8Title: '8. 条款变更',
    section8_1: '8.1. 我们保留随时修改这些条款的权利。任何更改将在发布到网站后立即生效。在发布更改后继续使用本网站即表示您接受此类更改。',
    section9Title: '9. 联系我们',
    section9_1: '9.1. 如果您对这些条款有任何疑问，请通过 support@sai.com 联系我们。使用本网站即表示您确认已阅读、理解并同意受这些条款的约束。',
  },

  // 复制成功/失败
  copy: {
    copiedToClipboard: '已复制到剪贴板',
    copyFailed: '复制失败',
  },

  // 错误提示
  errors: {
    networkError: '网络错误',
    pleaseSelectFilter: '请选择筛选条件',
    retry: '重试',
  },
}
